// Persistenza locale (localStorage) dei dati predefiniti della struttura e della firma del medico.
const KEY = "visioscreen_defaults_v1";

export function loadDefaults() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveDefaults(patch) {
  const next = { ...loadDefaults(), ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    // storage pieno o non disponibile
  }
  return next;
}

export function clearDefaults() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    // no-op
  }
}

export function hasDefaults() {
  const d = loadDefaults();
  return !!(d.strutturaNome || d.strutturaIndirizzo || d.logo || d.firma || d.medico);
}
